import React from "react";
import BaseView from "../../DealPipeline/common/BaseView";
import { columns } from "./config";
import { getAllInventory } from "../../../Api";
import withData from "../../Data/withData";

function View(props: any) {
  return (
    <BaseView
      columns={columns}
      title="All Inventory"
      subtitle="Taycor works diligently to provide accurate accounting of equipment inventory that has been sold. If there are any discrepancies to what you see below, please reach out to your relationship manager."
      {...props}
    ></BaseView>
  );
}

export default withData(View, getAllInventory);
